import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import PaymentHistory from './payment-history-model'
import {
  CreatePaymentHistoryAsync,
  DeletePaymentHistoryAsync,
  LoadPaymentHistorysAsync,
} from './paymentHistory-thunk'
const initialState: paymentHistorySliceState = {
  paymentHistory: [],
  selected_paymentHistory: '',
  is_loading_paymentHistory: false,
  is_creating_paymentHistory: false,
  is_deleting_paymentHistory: false,
}
export interface paymentHistorySliceState {
  paymentHistory: PaymentHistory[]
  selected_paymentHistory?: string
  is_loading_paymentHistory: boolean
  is_creating_paymentHistory: boolean
  is_deleting_paymentHistory: boolean
}
export const paymentHistorySlice = createSlice({
  name: 'paymentHistory',
  initialState,
  reducers: {
    setSelectedpaymentHistory: (state, action) => {
      state.selected_paymentHistory = action.payload
    },
    clearStatepaymentHistory: (state) => {
      state.paymentHistory = []
      state.is_loading_paymentHistory = false
      state.is_creating_paymentHistory = false
      state.is_deleting_paymentHistory = false
    },
    mergepaymentHistory: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_paymentHistory = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.paymentHistory = merge(state.paymentHistory, payload) as any
        }
      }
    },

    add_paymentHistory: (state, action) => {
      if (action.payload) {
        state.paymentHistory = [...state.paymentHistory, action.payload]
      }
    },
    set_paymentHistory: (state, action) => {
      let { key, value, id } = action.payload
      state.paymentHistory = state.paymentHistory.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadPaymentHistorysAsync.pending, (state) => {
      state.is_loading_paymentHistory = true
    })
    builder.addCase(LoadPaymentHistorysAsync.fulfilled, (state, action) => {
      state.is_loading_paymentHistory = false
      if (action.payload) {
        state.paymentHistory = action.payload
      }
    })
    builder.addCase(LoadPaymentHistorysAsync.rejected, (state) => {
      state.is_loading_paymentHistory = false
    })
    builder.addCase(CreatePaymentHistoryAsync.pending, (state) => {
      state.is_creating_paymentHistory = true
    })
    builder.addCase(CreatePaymentHistoryAsync.fulfilled, (state) => {
      state.is_creating_paymentHistory = false
    })
    builder.addCase(CreatePaymentHistoryAsync.rejected, (state) => {
      state.is_creating_paymentHistory = false
    })
    builder.addCase(DeletePaymentHistoryAsync.pending, (state) => {
      state.is_deleting_paymentHistory = true
    })
    builder.addCase(DeletePaymentHistoryAsync.fulfilled, (state, action) => {
      state.is_deleting_paymentHistory = false
      if (state.paymentHistory) {
        state.paymentHistory = state.paymentHistory.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeletePaymentHistoryAsync.rejected, (state) => {
      state.is_deleting_paymentHistory = false
    })
  },
})

export const {
  clearStatepaymentHistory,
  setSelectedpaymentHistory,
  set_paymentHistory,
  mergepaymentHistory,
  add_paymentHistory,
} = paymentHistorySlice.actions

export const get_paymentHistory =
  (id?: string) =>
  (state: {
    paymentHistory: {
      paymentHistory: PaymentHistory[]
    }
  }): PaymentHistory | null => {
    let temp = state?.paymentHistory?.paymentHistory?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.paymentHistory?.paymentHistory[0] || null
  }
export const get_selected_paymentHistory = (state: {
  paymentHistory: paymentHistorySliceState
}): PaymentHistory | null => {
  let id = state?.paymentHistory?.selected_paymentHistory
  let temp = state?.paymentHistory?.paymentHistory?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_paymentHistory = (state: {
  paymentHistory: {
    paymentHistory: PaymentHistory[]
  }
}): PaymentHistory[] => {
  let temp = state?.paymentHistory?.paymentHistory
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_paymentHistory_busy = (state: {
  paymentHistory: paymentHistorySliceState
}) => {
  return (
    state?.paymentHistory.is_deleting_paymentHistory ||
    state?.paymentHistory.is_loading_paymentHistory ||
    state?.paymentHistory.is_creating_paymentHistory
  )
}
export const is_deleting_paymentHistory_busy = (state: {
  paymentHistory: paymentHistorySliceState
}) => {
  return state?.paymentHistory.is_deleting_paymentHistory
}
export const is_loading_paymentHistory_busy = (state: {
  paymentHistory: paymentHistorySliceState
}) => {
  return state?.paymentHistory.is_loading_paymentHistory
}
export const is_creating_paymentHistory_busy = (state: {
  paymentHistory: paymentHistorySliceState
}) => {
  return state?.paymentHistory.is_creating_paymentHistory
}

export default paymentHistorySlice.reducer
